import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  InputGroup,
  Button,
  Breadcrumb,
  Pagination,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import PopUpCreateLoan from "../../components/popup/PopUpCreateLoan";
import { useStore } from "../../store";
import { add_loan, get_loans } from "../../services/loan.service";
import moment from "moment";
import convertPercent from "../../helpers/convertPercent";
import convertNumber from "../../helpers/convertNumber";
import convertTypeLoan from "../../helpers/convertTypeLoan";
import convertStatusLoan from "../../helpers/convertStatusLoan";
import LoadingComponent from "../../components/LoadingComponent";
import EmptyComponent from "../../components/EmptyComponent";
import PopUpAlertWarning from "../../components/popup/PopUpAlertWarning";
import ReactPaginate from "react-paginate";
import cutBranchNo from "../../helpers/cutBranchNo";
import addBranchNo from "../../helpers/addBranchNo";
import PopUpConfirmDiscretion from "../../components/popup/PopUpConfirmDiscretion";

let limitData = 50;

export default function LoanPage() {
  const navigate = useNavigate();
  // state
  const [popup, setPopup] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [loanDataList, setLoanDataList] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [totalPagination, setTotalPagination] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [totalDataList, setTotalDataList] = useState(0);
  const [backupFormData, setBackupFormData] = useState();

  // store
  const { token, branchData } = useStore();

  // useEffect
  useEffect(() => {
    getData();
  }, [pagination, filterStatus]);

  const handleClick = () => {
    navigate("/loan/formload"); // Replace '/new-page' with your desired route
  };

  // function
  const handleSearch = () => {
    getData();
  };
  const getData = async () => {
    try {
      setIsLoading(true);
      let findby = "?";
      findby += `skip=${(pagination - 1) * limitData}&`;
      findby += `limit=${limitData}&`;
      // findby += `memberNo=${searchInput}&`;
      if (searchInput) {
        findby += `memberNo=${addBranchNo(searchInput, branchData?.branchNo)}&`;
      }
      if (filterStatus) {
        if (filterStatus === "WAITTING") {
          findby += `loanStatus=${filterStatus}&activeStatus=ACTIVE&`;
        } else {
          findby += `activeStatus=${filterStatus}&`;
        }
      }

      const data = await get_loans(findby, token);
      if (data?.error) throw new Error(data?.message);
      let banlance = data?.data;
      setTotalDataList(data?.total);
      setTotalPagination(Math.ceil(data?.total / limitData));
      setLoanDataList(banlance);
      console.log(banlance);
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const handleCreateLoan = async (data) => {
    try {
      const _res = await add_loan(data, token);
      if (_res?.error) throw new Error("ມີບາງຢາງຜິດພາດ");
      getData();
      return { error: false };
    } catch (err) {
      console.error(err);
      return { error: true };
    }
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item active>ປ່ອຍກູ້ ແລະ ເກັບຄືນ</Breadcrumb.Item>
      </Breadcrumb>
      <Card
        style={{
          padding: 16,
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 100,
        }}
      >
        <h2>ຕາຕະລາງປ່ອຍກູ້ ແລະ ເກັບຄືນ</h2>
        <div
          style={{
            display: "flex",
            gap: 16,
            alignItems: "flex-end",
            marginBottom: 16,
          }}
        >
          <div>
            <label>ຄົ້ນຫາ</label>
            <InputGroup style={{ maxWidth: 230 }}>
              <Form.Control
                placeholder="ປ້ອນເລກສະມາຊິກ"
                style={{ paddingLeft: 10 }}
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              />
              <Button
                style={{ width: 40, padding: 0 }}
                onClick={() => handleSearch()}
              >
                <Icon icon="tabler:search" style={{ width: 20, height: 20 }} />
              </Button>
            </InputGroup>
          </div>
          <div>
            <label>ສະແດງຕາມສະຖານະ</label>
            <Form.Select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="">ທັງໝົດ</option>
              <option value="CLOSED">ປິດງວດ</option>
              <option value="ACTIVE">ຍັງບໍ່ປິດງວດ</option>
              <option value="WAITTING">ຍັງບໍ່ປິດງວດຊຳລະມື້ນີ້</option>
            </Form.Select>
          </div>
          <div style={{ flex: 1 }}></div>
          {/* <div>
            <Button
              onClick={() => {
                setPopup({ PopUpCreateLoan: true });
              }}
              size="md"
            >
              ສ້າງລາຍການ1
            </Button>
          </div> */}
          <div>
            <Button onClick={handleClick}>ສ້າງລາຍການ</Button>
          </div>
        </div>
        {/* loading */}
        <div
          style={{
            width: "100%",
            display: isLoading ? "flex" : "none",
            justifyContent: "center",
            padding: 20,
            height: 400,
            alignItems: "center",
          }}
        >
          <LoadingComponent />
        </div>
        <div
          style={{
            width: "100%",
            display: loanDataList?.length === 0 && !isLoading ? "flex" : "none",
            justifyContent: "center",
            padding: 20,
            height: 400,
            alignItems: "center",
          }}
        >
          <EmptyComponent />
        </div>
        {/*  */}
        <div
          style={{
            color: "#6c757d",
            fontSize: 14,
            fontWeight: 700,
            padding: "0px 10px",
            display: !isLoading ? "block" : "none",
          }}
        >
          ທັງໝົດ {totalDataList} ລາຍການ
        </div>
        <div
          style={{
            overflow: "auto",
            display: loanDataList?.length > 0 && !isLoading ? "block" : "none",
          }}
        >
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>ລະຫັດລາຍການ</th>
                <th>ເລກສະມາຊິກ</th>
                <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                <th>ງວດຊຳລະ</th>
                <th>ຈຳນວນເງິນທີ່ຕ້ອງຊຳລະ (ກີບ)</th>
                <th>ຈຳນວນເງິນກູ້ (ກີບ)</th>
                <th>ດອກເບ້ຍ</th>
                <th>ສະຖານະ</th>
                <th>ວັນເວລາປ່ອຍກູ້</th>
                <th>ຜູ້ສ້າງລາຍການ</th>
              </tr>
            </thead>
            <tbody>
              {loanDataList.map((e, i) => (
                <tr
                  onClick={() => navigate(`/loan/detail/${e?._id}`)}
                  className="hover"
                  key={i}
                >
                  <td>{e?.loanNo || "-"}</td>
                  <td>
                    {e?.memberId?.memberNo
                      ? cutBranchNo(e?.memberId?.memberNo)
                      : "-"}
                  </td>
                  <td>
                    <div>{e?.memberId?.fullName || "-"}</div>
                    {e?.memberId?.isDelete ? (
                      <div style={{ fontSize: 14, color: "red" }}>
                        ຍົກເລີກການເປັນສະມາຊິກແລ້ວ
                      </div>
                    ) : (
                      <div />
                    )}
                  </td>
                  <td>
                    <span style={{ color: "#0178C1" }}>
                      {e?.latestInstallmentNote?.installmentNoteNo || "-"}
                    </span>{" "}
                    / {e?.loanTerm || "-"}
                  </td>
                  <td style={{ color: "#0178C1" }}>
                    {e?.totalRepaymentAmount
                      ? convertNumber(e?.totalRepaymentAmount)
                      : "-"}
                  </td>
                  <td>{e?.loanAmount ? convertNumber(e?.loanAmount) : "-"}</td>
                  <td>
                    {e?.interestRate ? convertPercent(e?.interestRate) : "-"}
                  </td>
                  <td>
                    {e?.loanStatus ? convertStatusLoan(e?.loanStatus) : "-"}
                  </td>
                  <td>
                    {e?.createdAt
                      ? moment(e?.createdAt).format("DD/MM/YYYY HH:mm")
                      : "-"}
                  </td>
                  <td>{e?.createdBy?.fullName || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            width: "100%",
            bottom: 20,
          }}
        >
          <ReactPaginate
            previousLabel={
              <span className="glyphicon glyphicon-chevron-left">{`<`}</span>
            }
            nextLabel={
              <span className="glyphicon glyphicon-chevron-right">{`>`}</span>
            }
            breakLabel={<Pagination.Item disabled>...</Pagination.Item>}
            breakClassName={"break-me"}
            pageCount={totalPagination} // Replace with the actual number of pages
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={(e) => {
              console.log(e);
              setPagination(e?.selected + 1);
            }}
            containerClassName={"pagination justify-content-center"} // Bootstrap class for centering
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
          />
        </div>
      </Card>
      {/* popup */}
      <PopUpCreateLoan
        popup={popup}
        open={popup?.PopUpCreateLoan}
        onClose={() => setPopup()}
        onSubmit={handleCreateLoan}
        setPopup={setPopup}
        backupFormData={backupFormData}
        setBackupFormData={setBackupFormData}
      />
      {/* <PopUpAlertWarning title="ແຈ້ງເຕືອນ" open /> */}
      {/* DONE: ຍືນຍັນ ດຸນພິນິດ ກູ້ເງິນ */}
      <PopUpConfirmDiscretion //for updata activity history
        open={popup?.PopUpConfirmDiscretion_for_create}
        onClose={() => {
          setPopup({ PopUpCreateLoan: true });
        }}
        onSubmit={() => {
          setBackupFormData((prev) => ({
            ...prev,
            formData: { ...prev?.formData, manualCheck: true },
          }));
          setPopup({ PopUpCreateLoan: true });
        }}
        sub={
          <div>
            ຈຳນວນເງິນດັ່ງກ່າວໄດ້ເກີນຂັ້ນຕ່ຳ ຫຼື ເກີນຂັ້ນສູງສຸດທີ່ທາງກອງທຶນ
            ເຮົາໄດ້ກຳນົດໄວ້, ເຊິ່ງຖ້າທ່ານຕ້ອງການປ່ອຍກູ້ຫຼຸດ ຫຼື ເກີນຈຳນວນນີ້,
            ທຸລະກຳດັ່ງກ່າວແມ່ນຜ່ານດຸນພິນິດຂອງຄະນະກຳມະການກອງທຶນບ້ານແລ້ວ{" "}
            <span style={{ fontWeight: "bold", color: "#343A40" }}>ຍອມຮັບ</span>
            ເພື່ອເປັນການເຮັດທຸລະກຳສຳເລັດ
          </div>
        }
      />
    </div>
  );
}
